import { render, staticRenderFns } from "./fuwuLeft.vue?vue&type=template&id=e8de5dba&scoped=true"
import script from "./fuwuLeft.vue?vue&type=script&lang=js"
export * from "./fuwuLeft.vue?vue&type=script&lang=js"
import style0 from "./fuwuLeft.vue?vue&type=style&index=0&id=e8de5dba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8de5dba",
  null
  
)

export default component.exports